
export default function OrganizationIntro() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left: Logo and Text */}
          <div>
            <div className="flex items-center gap-3 md:gap-4 mb-6 md:mb-8">
              <div className="w-14 h-14 md:w-20 md:h-20 bg-[#2A7A62] rounded-xl md:rounded-2xl flex items-center justify-center">
                <i className="ri-water-flash-line text-2xl md:text-4xl text-white"></i>
              </div>
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#1E1E1E]">点滴公益</h2>
                <p className="text-[#6C6C6C] text-xs md:text-sm">Droplet Care Project</p>
              </div>
            </div>
            
            <div className="space-y-4 md:space-y-6 text-[#1E1E1E] leading-relaxed">
              <p className="text-base md:text-lg">
                "点滴公益"是由重庆市南岸区明明德志愿服务中心发起的公益项目，旨在为城市一线工作者提供清凉关怀，让每一份爱心都能精准送达需要帮助的人手中。
              </p>
              
              <p className="text-sm md:text-base">
                我们深知，城市的正常运转离不开环卫工人、快递员、建筑工人等一线劳动者的辛勤付出。他们在烈日下、寒风中坚守岗位，用汗水和努力守护着我们的美好生活。
              </p>
              
              <p className="text-sm md:text-base">
                通过"点滴公益"，我们希望汇聚社会各界的爱心力量，为这些城市守护者送上一瓶清凉的水、一份温暖的关怀。每一次捐赠都透明公开，每一瓶水都有迹可循。
              </p>
              
              <div className="grid grid-cols-3 gap-4 md:gap-6 pt-4 md:pt-6">
                <div className="text-center">
                  <div className="text-xl md:text-3xl font-bold text-[#2A7A62] mb-1 md:mb-2">2026</div>
                  <div className="text-xs md:text-sm text-[#6C6C6C]">项目发起年份</div>
                </div>
                <div className="text-center">
                  <div className="text-xl md:text-3xl font-bold text-[#2A7A62] mb-1 md:mb-2">38+</div>
                  <div className="text-xs md:text-sm text-[#6C6C6C]">覆盖区县</div>
                </div>
                <div className="text-center">
                  <div className="text-xl md:text-3xl font-bold text-[#2A7A62] mb-1 md:mb-2">100%</div>
                  <div className="text-xs md:text-sm text-[#6C6C6C]">透明公开</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Image */}
          <div className="relative mt-8 lg:mt-0">
            <div className="relative rounded-xl md:rounded-2xl overflow-hidden shadow-xl md:shadow-2xl">
              <img 
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 600'%3E%3Crect fill='%23e5e7eb' width='800' height='600'/%3E%3C/svg%3E"
                alt="点滴公益志愿者活动"
                className="w-full h-[300px] md:h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-4 md:-bottom-8 left-4 md:-left-8 bg-white rounded-lg md:rounded-xl shadow-lg md:shadow-xl p-4 md:p-6 max-w-[200px] md:max-w-xs">
              <div className="flex items-center gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-[#F4B942] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-fill text-xl md:text-2xl text-white"></i>
                </div>
                <div>
                  <div className="text-lg md:text-2xl font-bold text-[#2A7A62]">15,680+</div>
                  <div className="text-xs md:text-sm text-[#6C6C6C]">累计受助人次</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
